import React, { Component } from 'react'
import { Box, Divider, Typography } from "@mui/material";
import ProofHeader from '../../components/proof/ProofHeader';
import ProofBody from '../../components/proof/ProofBody';
import ProofFooter from '../../components/proof/ProofFooter';
import RejectModal from '../../components/proof/RejectModal';
import { useNavigate } from 'react-router-dom';
import { setRejectComment, setRejectModalOpen } from '../../store/job/jobSlice';

class ProofContainer extends Component {
  componentDidMount() {
    const { proof_id } = this.props;
    this.props.get_viewproof({ proof_id });
  }

  // componentDidUpdate(prevProps) {
  //   const { proof_data,proof_log_data } = this.props;

  //   if (proof_data !== prevProps.proof_data && proof_data?.length > 0) {
  //     const job_id = proof_data[0].job_id;
  //     this.props.proof_log_table({ job_id });
  //     console.log("proof_log_data", proof_log_data);
  //   }
  // }

  handleApprove = async () => {
    const { proof_data, proof_approve, navigate } = this.props;
    try {
      const proof_ids = proof_data.map(item => item.id);
      await proof_approve({ proof_id: proof_ids });
      navigate("/proof-status",
        {
          state: { status: "approve" },
          replace: true
        });
      window.location.reload();
    } catch (error) {
      console.error(error);
    }
  };
  handleReject = async (reject_comment) => {
    const { proof_data, proof_reject, navigate } = this.props;
    try {
      const proof_ids = proof_data.map(item => item.id);
      await proof_reject({ proof_id: proof_ids, comment: reject_comment });
      navigate("/proof-status",
        {
          state: { status: "reject" },
          replace: true
        });
      window.location.reload();
    } catch (error) {
      console.log(error)
    }
  }
  render() {
    const { proof_data, proofLoading, is_reject_modal_open, reject_comment } = this.props;
    const isExpired = proof_data?.length > 0 && proof_data.every(item => item.sent_approved_files === 4);
    if (isExpired) {
      return (
        <Box
          sx={{
            width: "100vw",
            height: "100vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            bgcolor: "#f5f5f5",
            textAlign: "center",
            p: 3,
          }}
        >
          <Typography variant="h4" sx={{ mb: 2, fontWeight: 600 }}>
            This eProof is Expired
          </Typography>
          <Typography variant="h6">
            THANK YOU!
          </Typography>
        </Box>
      );
    }

    // Normal proof page
    return (
      <Box
        sx={{
          width: "100vw",
          height: "100vh",
          display: "flex",
          flexDirection: "column",
          p: 0,
          px: 1,
          pb: 1,
          bgcolor: "#fafafa",
        }}
      >
        <ProofHeader
          proof_id={this.props.proof_id}
          proof_data={proof_data}
          proofLoading={proofLoading}
          onApprove={this.handleApprove}
          onReject={() => this.props.dispatch(setRejectModalOpen(true))}
        />

        <Box sx={{ flex: 1, overflowY: "auto" }}>
          <ProofBody
            proof_data={proof_data}
            proofLoading={proofLoading}
            is_reject_modal_open={is_reject_modal_open}
            reject_comment={reject_comment}
            onApprove={this.handleApprove}
            onReject={() => this.props.dispatch(setRejectModalOpen(true))}
          />
        </Box>

        {!proofLoading && (
          <ProofFooter
            proof_data={proof_data}
            is_reject_modal_open={is_reject_modal_open}
            reject_comment={reject_comment}
            onApprove={this.handleApprove}
            onReject={() => this.props.dispatch(setRejectModalOpen(true))}
          />
        )}
        <RejectModal
          is_reject_modal_open={is_reject_modal_open}
          reject_comment={reject_comment}
          onReject={this.handleReject}
          onClose={() => this.props.dispatch(setRejectModalOpen(false))}
        />
      </Box>
    );
  }
}

export default ProofContainer;
